import { Props_SnippetButtons } from './Buttons.props'
import SnippetLink from '../Shared/Link/Link'
import { CompileHeadingToSpan } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

export const SnippetButtons = (props: Props_SnippetButtons) => {
    const {headingProps, linksAlignment, repeatable_link} = props;

    const titleClass = headingProps.visibility.value  ? "snippet-buttons__heading" : "snippet-buttons__heading accessible-heading";
    const linksAlignmentClass = `snippet-buttons__links snippet-buttons__links--${linksAlignment.alignment.value}`;

    return (
    <section className='snippet-buttons'>
        <div className="snippet-buttons__container">
            <h2 className={titleClass}>{CompileHeadingToSpan(headingProps.heading?.value || '')}</h2>
            <div className={linksAlignmentClass}>
            {repeatable_link?.map((link, index) => (
                <SnippetLink
                    key={index}
                    className="snippet-buttons__link"
                    linkStyles={link.linkStyle?.value}
                    openInNewTab={link.linkTarget?.value}
                    url={link.linkHref?.value}
                >
                    {link.linkText?.value}
                </SnippetLink>
            ))}
            </div>
        </div>
    </section>
    )
}
